import { Singleton } from 'app/utils';
import axios from 'axios';

export interface StringMap { [name: string] : string };

function formData(data: StringMap): FormData {
    let fd = new FormData();
    Object.entries(data).forEach(([k, v]) => fd.append(k, v));
    return fd;
}

export class SalesforceResource {
    public env: string;
    public token: string;

    public initialize(env: string, token: string) {
        this.env = env;
        this.token = token;
    }

    private getEnvString() {
        if (['prod', 'stage'].includes(this.env)) return '';
        if (this.env === 'local') return 'dev.';
        return `${this.env}.`;
    }

    public url(path: string) {
        return `https://corpsys-salesforce-services.${this.getEnvString()}spsc.io/${path}`;
    }

    public headers(custom={} as StringMap): StringMap {
        return {
            'Content-Type': 'multipart/form-data',
            'Authorization' : `Bearer ${this.token}`,
            ...custom
        }
    }

    public post(path: string, headers={} as StringMap, data?: any) {
        const { files, ...rest } = data;
        let fd = formData(rest);
        files.forEach(file => fd.append('files', file));
        return axios.post(this.url(path), fd, {
            headers: this.headers(headers)
        });
    }
}

export let $SalesforceResource = Singleton('$SalesforceResource', SalesforceResource);
